(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller(
      "ReserveLimitsController",
      ReserveLimitsController
    );

  ReserveLimitsController.$inject = ["$timeout", "$state"];

  function ReserveLimitsController($timeout, $state) {
    function loadReserveLimits() {
      var reserveLimitsEl = document.getElementById("reserve-limits");
      reserveLimitsEl.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.setting");
      });
      reserveLimitsEl.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.reserveLimitList");
      });
    }
    $timeout(loadReserveLimits, 100);
  }
})();
